/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { typeList, status, typeValue, severity } from "../../util/DataObject"
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const AccountBlockList = (props) => {

	const history = useHistory();
  const process = ["SPEI", "albo-albo", "billpayments", "ATM"];
  const [zPos, setZPos] = useState(45)
	const [disabled, setDisabled] = useState(true);
	const [edit, setEdit] = useState(false);
	const [newValue, setNewValue] = useState(false);
  
  const [countryName, setCountryName] = useState("");
  const [stateName, setStateName] = useState("");
  const [locality, setLocality] = useState([]);
  const [zip, setZip] = useState(false);

  const [address, setAddress] = useState({zip: '', country: '', town: '', street: '', locality: '', state: '', extnum: '', intnum: ''})
  const [addressError, setAddressError] = useState({zip: null, street: false, locality: false, extnum: false})
  
  const [name, setName] = useState({ gname: '', lname: '', sname: '', bdate: '' })
  const [nameError, setNameError] = useState({ gname: false, lname: false, bdate: false })

  const [business_name, setbusiness_name] = useState({ corporate_name: '', bcountry: '', bdate: '' })
  const [businesError, setbusinesError] = useState({ corporate_name: false })

  const typeValues: any = { address, name, business_name };
	
  const [form, setForm] = useState({ typeList: "", process: "", type: "", user: "", value: null, tracking_key: '', status: null, reason: '', severity: "", details: "", customer_uuid: ''});
  const [error, setErrors] = useState({ typeList: false, process: false, type: false, value: false, tracking_key: false, reason: false, severity: false });

  const [massiveLoad, setMassiveLoad] = useState(false)

	useEffect(() => {
		init();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const init = async () => {
    let d = {
			typeList: "",
			process: "",
			type: "",
			value: null,
			status: null,
      reason: "",
		};
    setDisabled(true);
    setMassiveLoad(false)

    if(props.contentModal && Object.keys(props.contentModal).length > 0){
      let data = props.contentModal
      if(data['items']['data'].length > 0){
        d.value = data['items']['data']
        d.type = data["items"]['type']
      }
      if(data['typeList']){
        d.typeList = data["typeList"]
      }
      setMassiveLoad(true)
		  setForm(JSON.parse(JSON.stringify(d)));
    } else {
      setForm(JSON.parse(JSON.stringify(d)));
    }    
	};

	const send = async () => {
		let user = JSON.parse(localStorage.session);
		props.changeLoader(true);
    setZPos(-1)
		let data = form;
		data["user"] = user["name"];
    
    if(form.type === 'address' || form.type === 'name' || form.type === 'business_name'){  
      Object.keys(typeValues[form.type]).map((i) => {
        if(typeValues[form.type][i]){
          data["value"] = {
            ...data["value"],
            [i] :  typeValues[form.type][i]
          } 
        }
        return data["value"]
      }) 
    }
    if(form.type === "name" && !form.value.hasOwnProperty("sname")){
      data["value"]["sname"] = ""
    }

    Object.keys(form).map((i) => {
      if(!form[i]){
        delete data[i]
      }
    })
    if(massiveLoad){
      data["values"] = data["value"];
    }

		let accountBlockList = await API.service( massiveLoad ? "listCreateBatch" : "accountBlockList", data, props.pos, props.changeAlert, props.changeLoader, history);
		if (accountBlockList.status === 200) {
			if (accountBlockList.data.data.response === "OK") {
        if(props.reload){
          await props.reload()
        }        
				props.changeAlert(true, "success", "Registro realizado con éxito");
				closelightbox();
			}
		} else {
      let detail = accountBlockList.data.data.message;
      props.changeAlert(true, "error", "Error: " + detail);
    }
		props.changeLoader(false);
    setZPos(45)
	};

  const editRegister = async () => {
		let user = JSON.parse(localStorage.session);

		props.changeLoader(true);
    setZPos(-1)
		let data = form;
		data["user"] = user["name"];
    if(!status){
      delete data["status"]
    }

    if(form.type === 'address' || form.type === 'name' || form.type === 'business_name'){       
      Object.keys(typeValues[form.type]).map((i) => {
        data["value"] = {
          ...data["value"],
          [i] :  typeValues[form.type][i]
        } 
        return data["value"]
      })
    }

		let editResponse = await API.service( "editRegisterList", data, props.pos, props.changeAlert, props.changeLoader, history);
		if (editResponse.status === 200) {
			if (editResponse.data.data.response === "OK") {
        await props.reload()
				props.changeAlert(true, "success", "Registro editado con éxito");
				closelightbox();
			}
		}
		props.changeLoader(false);
    setZPos(45)
	};

	const changeValue = async (field, e) => {
		let f = form;
		let er = error;	
    let a = address;
    let aE = addressError;
    let n = name;
    let nE = nameError;
    let b = business_name;
    let bE = businesError;

		if (field) {
			f[field] = e.target.value;
      if(e.target.value === "name" && typeof(f.value) === "string"){
        f.value = null
        f.typeList = "black"
        setForm(JSON.parse(JSON.stringify(f)));
        validateName(n, nE);
      } else if(e.target.value === "address" && typeof(f.value) === "string"){
        f.typeList = "black"
        f.value = null
        setForm(JSON.parse(JSON.stringify(f)));
        validateAddress(a, aE);
      }  else if(e.target.value === "business_name" && typeof(f.value) === "string"){
        f.typeList = "black"
        f.value = null
        setForm(JSON.parse(JSON.stringify(f)));
        validateBusiness(a, aE);
      } else {
        if (!e.target.value ) {
          er[field] = true;
        } else {
          er[field] = false;
        }

        if (f.typeList === "white" && !f.process && !e.target.value ) {
          er["process"] = true;
        } else {
          er["process"] = false;
        }

        if((form.type === 'address' || form.type === 'name')){
          f.typeList = "black"
        }
        if((form.type !== 'address' && form.type !== 'name' && (typeof(form.value) === "object") && (!Array.isArray(form.value)))){
          f["value"] = ""
        }
        if(f.type === 'taxid' ||  f.type === 'populationid' ||  f.type === 'uuid' ||  f.type === 'business_name' ||  f.type === 'card' ||  f.type === 'device_id' ||  f.type === 'ip' ||  f.type === 'fingerprint' ){
          setNewValue(true)
        } else {
          setNewValue(false)
        }
  
        if(field == 'typeList'){
          f['tracking_key'] = "";
          er['tracking_key'] = false;          
        }
        setForm(JSON.parse(JSON.stringify(f)));
        setErrors(JSON.parse(JSON.stringify(er)));
        validateForm(f, er);

        if(address.zip && f.type === "address"){
          validateAddress(a, aE);
        }
        if(f.type === "name"){
          validateName(n, nE);
        }
        if(f.type === "business_name"){
          validateBusiness(b, bE);
        }
      }
      setForm(JSON.parse(JSON.stringify(f)));
      setErrors(JSON.parse(JSON.stringify(er)));
      validateForm(f, er);
		}

	};

  const validateForm = async (f, err) => {
    if(massiveLoad && f["typeList"] && f["type"] && f["reason"] && f["severity"] && f["value"].length > 0 ){
			setDisabled(false);
    } else if (f["typeList"] && f["type"] && f["reason"] && f["severity"] && 
      ((form.type !== 'address' && form.type !== 'name') ? f["value"] && !err["value"] : true ) && 
      ((form.typeList === 'white') ? f["process"] && !err["process"] : true ) && 
      ((form.type === 'address' ? validateAddress(address, addressError) : true)) && 
      ((form.type === 'business_name' ? validateBusiness(business_name, businesError) : true)) && 
      ((form.type === 'name' ? validateName(name, nameError) : true)) && 
      !err["typeList"] && !err["type"] && !err["reason"] && !err["severity"]) {
    
      if(f['typeList'] == 'debt'){
				if(f['tracking_key'] && !err['tracking_key']){
					setDisabled(false);
				} else {
					setDisabled(true);
				}
			} else {
				setDisabled(false);
			}
		} else {
			setDisabled(true);
		}
	};

  const secondChangeValue = async (field, e) => {
    let a = address;
    let aE = addressError;
    let n = name;
    let nE = nameError;
    let b = business_name;
    let bE = businesError;

    if (field) {     
      if(form.type === 'address' && address.hasOwnProperty(field)){
        if (!e.target.value) {
          aE[field] = "Dato obligatorio";
        } else {
          aE[field] = "";
        }

        a[field] = e.target.value;
        if(field === "zip" && e.target.value.length < 5){
          setZip(false)
        } 
        if(field === "zip" && e.target.value.length === 5){
          await getZip(e.target.value);
        } 
        
        setAddress(JSON.parse(JSON.stringify(a)));
        setAddressError(JSON.parse(JSON.stringify(aE)));
        validateAddress(a, aE);
      } 
      if(form.type === 'name' && name.hasOwnProperty(field)){
        if (!e.target.value) {
          nE[field] = true;
        } else {
          nE[field] = false;
        }

        n[field] = e.target.value;
        if(field === "bdate"){
          n[field] = new Date(e.target.value).toISOString()
        } 

        setName(JSON.parse(JSON.stringify(n)));
        setNameError(JSON.parse(JSON.stringify(nE)));
        validateName(n, nE);
      }
      if(form.type === 'business_name' && business_name.hasOwnProperty(field)){
        if (!e.target.value) {
          bE[field] = true;
        } else {
          bE[field] = false;
        }

        b[field] = e.target.value;
        if(field === "bdate"){
          b[field] = new Date(e.target.value).toISOString()
        } 

        setbusiness_name(JSON.parse(JSON.stringify(b)));
        setbusinesError(JSON.parse(JSON.stringify(bE)));
        validateBusiness(b, bE);
      }
    }
	};

  const validateAddress = (f, err) => {   
		if (f["zip"] && f["locality"] && f["street"] && f["extnum"] && form["typeList"] && form["reason"] && form["severity"] && !error["typeList"] && !err["extnum"]  && !err["street"] && !err["zip"] && !err["locality"] && !error["reason"] && !error["severity"]) {
      setDisabled(false);
      return true
		} else {
			setDisabled(true);
      return false
		}
	};

  const validateName = (f, err) => {
		if (f["gname"] && f["lname"] && form["reason"] && form["severity"] && !err["gname"] && !err["lname"] && !error["reason"] && !error["severity"]) {
      setDisabled(false);
      return true
		} else {
			setDisabled(true);
      return false
		}
	};

  const validateBusiness = (f, err) => {
		if (f["corporate_name"] && form["reason"] && form["severity"] && !err["corporate_name"] && !error["reason"] && !error["severity"]) {
      setDisabled(false);
      return true
		} else {
			setDisabled(true);
      return false
		}
	};

  const getZip = async (value) => {
    let a = address;
    let aE = addressError;

    props.changeLoader(true);
    setZPos(-1)
    let data = {
      catalog: {
        id: 'zip',
        filters: [{ key: value }]
      },
    };

    let request = await API.service('getCatalog', data, props.pos, props.changeAlert, props.changeLoader, props.history);
    if (request.status == 200) {
      if (request.data.data.response == 'OK') {
        let cat = request.data.data.catalog;
        if(cat.length > 0){
          a['country'] = cat[0]['m'][0]['country'];
          a['state'] = cat[0]['m'][0]['state_key'];
          a['town'] = cat[0]['m'][0]['municipality'];

          setCountryName(props.catalogs.country.filter((item) => {
            if(item.k === address.country){
              return item.v 
            }
          })[0]["v"])
          setStateName(props.catalogs.states.filter((item) => {
            if(item.k === address.state){
              return item.v 
            }
          })[0]["v"])
          setAddress(JSON.parse(JSON.stringify(a)));
          setZip(true)
        } else {
          aE["zip"] = "No se encontró información";
          setZip(false)
          setAddressError(JSON.parse(JSON.stringify(aE)));
        }

        let cols = [];
        for(let i = 0; i < cat.length; i++){
          cols.push(cat[i]['m'][0]['township']);
        }
        setLocality(cols);

        // -------------------------------------------------
        if(props.contentModal?.value){
          Object.keys(props.contentModal.value).map((d) => {
            a["zip"] = props.contentModal.value["zip"]
            a["extnum"] = props.contentModal.value["extnum"]
            a["intnum"] = props.contentModal.value["intnum"]
            a["street"] = props.contentModal.value["street"][0].toUpperCase() + props.contentModal.value["street"].substringing(1).toLowerCase()
          })
          cols.map((i) => {         
            if(i.toLowerCase() == props.contentModal.value.locality.toLowerCase()){
              a["locality"] = i
            }
          })
          setAddress(JSON.parse(JSON.stringify(a)))
        }
      }
    }
    props.changeLoader(false);
    setZPos(45)
  }

	return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
          {edit ? "Editar Registro" : "Bloqueo de Cuenta"}
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent>
          <Grid container spacing={2} sx={{ marginTop: "10px" }}>
            <Grid item xs={6}>
              <TextField label="Tipo de Dato" value={form.type} disabled={massiveLoad} select size="small" fullWidth onChange={changeValue.bind(this, "type")} >
                {typeValue?.map((i, index) => (
                  <MenuItem key={`type-${index}`} value={i.value}>{i.label}</MenuItem>
                ))}
              </TextField>
            </Grid>
            
            { form.type !== 'address' && form.type !== 'name' && form.type !== 'business_name' && !massiveLoad &&
                <Grid item xs={6}>
                  <TextField label="Dato del Alta" value={form.value ? form.value : ""} size="small" fullWidth onChange={changeValue.bind(this, "value")} variant="outlined"/>
                </Grid>
            }
            {massiveLoad &&
                <Grid item xs={6}>
                  <TextField disabled label="Carga masiva" value={`${form.value.length} Datos de alta`} size="small" fullWidth variant="outlined"/>
                </Grid>
            }

            <Grid item xs={6}>
              <TextField  label="Tipo de Lista" value={form.typeList} select size="small" fullWidth onChange={changeValue.bind(this, "typeList")} >
                {typeList?.map((i, index) => (
                  <MenuItem key={`typeList-${index}`} value={i.value}>{i.label}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField label="Motivo" value={form.reason || ""} size="small" fullWidth onChange={changeValue.bind(this, "reason")} error={error.reason} helperText={error.reason ? "Dato obligatorio" : ''}/>
            </Grid>
            <Grid item xs={6}>
              <TextField label="Severidad" value={form.severity || ""} select size="small" fullWidth onChange={changeValue.bind(this, "severity")} >
                {severity?.map((i, index) => (
                  <MenuItem key={`severity-${index}`} value={i.key}>{i.label}</MenuItem>
                ))}
              </TextField>
            </Grid>
            {!massiveLoad &&
              <Grid item xs={6}>
                <TextField label="UUID Cliente" value={form.customer_uuid} size="small" fullWidth onChange={changeValue.bind(this, 'customer_uuid')} />
              </Grid> 
            }

            { newValue && 
              <Grid item xs={6}>
                <TextField label="Detalle" value={form.details} size="small" fullWidth onChange={changeValue.bind(this, 'details')} />
              </Grid>
            }

            { form.type === 'address' && !massiveLoad &&
              <Grid item xs={6}>
                <TextField label="Código postal" value={address.zip} size="small" fullWidth onChange={secondChangeValue.bind(this, 'zip')} error={addressError.zip} helperText={addressError.zip ? "Dato obligatorio" : ''}  />
              </Grid>
            }
            { form.type === 'address' && zip && !massiveLoad &&
              <>
                <Grid item xs={6}>
                  <TextField label="País" value={countryName} size="small" disabled fullWidth />
                </Grid>
                <Grid item xs={6}>
                  <TextField label="Estado" value={stateName} size="small" disabled fullWidth />
                </Grid>
                <Grid item xs={6}>
                  <TextField label="Alcadia / Municipio" value={address.town} size="small" disabled fullWidth onChange={secondChangeValue.bind(this, 'town')}/>
                </Grid>
                <Grid item xs={6}>
                  <TextField label="Colonia" value={address.locality} size="small" select fullWidth onChange={secondChangeValue.bind(this, 'locality')}>
                    {locality?.map((i, index) => (<MenuItem key={`locality-${index}`} value={i}>{i}</MenuItem> ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField label="Calle" value={address.street} size="small" fullWidth onChange={secondChangeValue.bind(this, 'street')} error={addressError.street} helperText={addressError.street ? "Dato obligatorio" : ''} />
                </Grid>
                <Grid item xs={6}>
                  <TextField label="N° Ext." value={address.extnum} size="small" fullWidth onChange={secondChangeValue.bind(this, 'extnum')} error={addressError.extnum} helperText={addressError.extnum ? "Dato obligatorio" : ''} />
                </Grid>
                <Grid item xs={6}>
                  <TextField label="N° Int." value={address.intnum} size="small" fullWidth onChange={secondChangeValue.bind(this, 'intnum')}/>
                </Grid>
              </>
            }

            { form.type === 'name' && !massiveLoad &&
              <>
                <Grid item xs={6}>
                  <TextField label="Nombre" value={name.gname} onChange={secondChangeValue.bind(this, 'gname')} error={nameError.gname} helperText={nameError.gname ? "Dato obligatorio" : ''} size="small" fullWidth/>
                </Grid>
                <Grid item xs={6}>
                  <TextField label="Apellido paterno" value={name.lname} onChange={secondChangeValue.bind(this, 'lname')} error={nameError.lname} helperText={nameError.lname ? "Dato obligatorio" : ''} size="small" fullWidth/>
                </Grid>
                <Grid item xs={6}>
                  <TextField label="Apellido materno" value={name.sname} onChange={secondChangeValue.bind(this, 'sname')} size="small" fullWidth/>
                </Grid> 
                <Grid item xs={6}>
                  <TextField type={"date"} label={"Fecha de nacimiento"} InputLabelProps={{ shrink: true }}
                    value={ name.bdate ? new Date(name.bdate).toJSON().substring(0, 10) : name.bdate  } error={nameError.bdate} helperText={nameError.bdate ? "Dato obligatorio" : ''} size="small" fullWidth 
                    onChange={secondChangeValue.bind(this, 'bdate')}                 
                  />
                </Grid>     
              </>
            }

            { form.type === 'business_name' && !massiveLoad &&
              <>
                <Grid item xs={6}>
                  <TextField label="Nombre Empresa" value={business_name.corporate_name} onChange={secondChangeValue.bind(this, 'corporate_name')} error={businesError.corporate_name} helperText={businesError.corporate_name ? "Dato obligatorio" : ''} size="small" fullWidth/>
                </Grid>
                <Grid item xs={6}>
                  <TextField select value={business_name.bcountry || -1} onChange={secondChangeValue.bind(this, 'bcountry')} size="small" fullWidth color="secondary">
                      <MenuItem value={-1} disabled>Seleccione</MenuItem>
                      {props.catalogs?.country?.map((item, key) => (
                          <MenuItem key={`country-${item.k}-${key}`} value={item.k}>{item.v}</MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField type={"date"} label={"Fecha Constitución"} InputLabelProps={{ shrink: true }}
                    value={ business_name.bdate ? new Date(business_name.bdate).toJSON().substring(0, 10) : business_name.bdate} size="small" fullWidth 
                    onChange={secondChangeValue.bind(this, 'bdate')}                 
                  />
                </Grid>     
              </>
            }

            { edit &&
              <Grid item xs={6}>
                <TextField label="Estatus" value={form.status ? form.status : ""} size="small" select fullWidth onChange={changeValue.bind(this, "status")}>
                  {status?.map((i, index) => (<MenuItem key={`locality-${index}`} value={i.value}>{i.label}</MenuItem> ))}
                </TextField>
              </Grid>
            }

            { form.typeList == 'debt' &&
              <Grid item xs={6}>
                <TextField label="Tracking key" value={form.tracking_key ? form.tracking_key : ""} size="small" fullWidth onChange={changeValue.bind(this, "tracking_key")} />
              </Grid>  
            }        
          </Grid>
        </DialogContent>

        <DialogActions>    
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          <Button disabled={disabled} variant="contained" onClick={edit ? editRegister.bind(this) : send.bind(this)} >{edit ? "Editar" : "Agregar"}</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog> 
	);
};

export default AccountBlockList;
